import { render } from "./App.vue?vue&type=template&id=753e2cf4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\Studio Sport\\ECM_HYBRID_STUDIO_SPORT\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__